
import React from 'react';

const UsekListDetail = ({
    usekCount,
}) => {

    return (
        <div>
            <div>{`Počet navržených úseků mezí: ${usekCount}`}</div>
        </div>
    );
}

export default UsekListDetail;
